import React, { useCallback } from 'react';
import TipSelectionModal from '../component/Modals/TipSelection/TipSelectionModal';
import useBehaviorSubjectState from '../hooks/rxjs/useSubjectState';
import { answerTipRequest, embeddedTipRequest$ } from './embedded';

const EmbeddedTipPrompt: React.FC = () => {
  const { value: request } = useBehaviorSubjectState(embeddedTipRequest$);
  const requestId = request?.requestId ?? '';

  const onContinue = useCallback(
    (tipAmount: number) => answerTipRequest(requestId, { tipAmount }),
    [requestId],
  );
  const onSkip = useCallback(
    () => answerTipRequest(requestId, { tipAmount: 0 }),
    [requestId],
  );
  const onClose = useCallback(
    () => answerTipRequest(requestId, { cancelled: true }),
    [requestId],
  );

  if (!request) return null;
  return (
    <TipSelectionModal
      key={request.requestId}
      amount={request.amount}
      tipOptions={request.tipOptions}
      onContinue={onContinue}
      onSkip={onSkip}
      onClose={onClose}
    />
  );
};

export default EmbeddedTipPrompt;
